export const AddSquare = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8 16H24" stroke="currentColor" stroke-width="2"/>
  <path d="M16 8L16 24" stroke="currentColor" stroke-width="2"/>
  <rect x="3" y="3" width="26" height="26" rx="1" stroke="currentColor" stroke-width="2"/>
</svg>`;
